<template>
    <div>
        <div class="banner-container">
            <img class="career-img" src="../../assets/image/career/career-banner.jpg" />
            <p class="join-title">Join Our Team</p>
        </div>
        <el-breadcrumb class="breadcrumb-container" separator="/">
            <el-breadcrumb-item class="breadcrumb-item" :to="{ path: '/career' }">Career</el-breadcrumb-item>
            <el-breadcrumb-item class="breadcrumb-item">{{ $t("Career['SaleExecutive']['SaleExecutive']") }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="job-container">
            <p class="title">{{ $t("Career['SaleExecutive']['SaleExecutive']") }}</p>
            <div class="description-container">
                <p class="subtitle"> {{ $t("Career['job_responsibilities']") }}</p>
                <ul class="requirement-list">
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility1']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility2']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility3']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility4']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility5']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility6']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility7']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['responsibility8']") }}</li>
                </ul>
                <p class="salary">SALARY: NEGOTIABLE</p>
                <p class="subtitle">{{ $t("Career['job_requirements']") }}</p>
                <ul class="requirement-list">
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements1']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements2']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements3']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements4']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements5']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements6']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements7']") }}</li>
                    <li class="list-details"> {{ $t("Career['SaleExecutive']['requirements8']") }}</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">How to Apply</p>
                <p class="requirement-list">Interested candidates please submit your CV/resume with a photo and accompanied by cover letter and any other supporting documents to HR Department:</p>
                <div class="hr-contact">
                    <p class="hr-contact-details">Contact Person : HR Department</p>
                    <p class="hr-contact-details">Email: hr@u-pay.com</p>
                    <p class="hr-contact-details">Contact: 069 931 888 / 077 266 123 </p>
                    <p class="hr-contact-details">Website: www.u-pay.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.banner-container {
  position: relative;
  .career-img {
    width: 100%;
  }
  .join-title {
    color: white;
    position: absolute;
    bottom: 3%;
    left: 4%;
    font-size: 2.2rem;
    font-weight: bolder;
  }
}
.job-container {
    display: table;
    margin-right: auto;
    margin-left: auto;
    padding: 3% 25% 3% 25%;
    .title {
        color: #0277E3;
        text-align: center;
        font-size: 1.55rem;
        font-weight: bold;
    }
}

.description-container{
    padding-top: 8%;
    .subtitle {
        color: black;
        text-align: center;
        font-size: 1.35rem;
        font-weight: bold;
    }
    .requirement-list{
        margin: 3% 0% 5% 0%;

        .list-details {
            margin-bottom: 0.5%;
            display: list-item;
            list-style-type: disc;
        }
    }
    .salary{
        font-weight: bolder;
    }

    .hr-contact .hr-contact-details {
        margin-bottom: 3%;
        font-weight: bold;
    }
}
.breadcrumb-container {
    margin : 3% 3%;
}

.breadcrumb-item {
    color: darkgray;
    font-weight: 600;
    font-size: 1.0rem;
}

@media only screen and (max-width: 600px) {
    .job-container {
        display: table;
        margin-right: auto;
        margin-left: auto;
        padding: 3% 5% 3% 5%;
        .title {
            color: #0277E3;
            text-align: center;
            font-size: 1.10rem;
            font-weight: bold;
        }
    }
}
</style>
